export default {
  data: () => ({
    animationFrames: null,
    minAnimationTime: 300,
    targetFrameRate: 60,
    frameRate: 30,
  }),
  methods: {
    getAnimationFrames(targetFrame) {
      let currentFrame = this.frameNumber
      targetFrame = this.getFrameNumber(targetFrame)

      if (this.disable360) return [targetFrame]

      const dist = Math.abs(targetFrame - currentFrame)
      let dir = currentFrame < targetFrame ? 1 : -1
      if (dist > this.frameCount / 2) {
        dir = -dir
      }

      const frames = []
      while (currentFrame !== targetFrame && frames.length < 72) {
        currentFrame += dir

        if (currentFrame <= 0) {
          currentFrame += this.frameCount
        }
        if (currentFrame > this.frameCount) {
          currentFrame -= this.frameCount
        }

        frames.push(currentFrame)
      }

      return frames
    },
    animateTo(targetFrame) {
      // Get an array of frames to animate between
      this.animationFrames = this.getAnimationFrames(targetFrame)

      // Determine frameRate to ensure minAnimationTime is satisfied
      this.frameRate = Math.min(
        this.targetFrameRate,
        (1000 * this.animationFrames.length) / this.minAnimationTime
      )

      // Start the animation
      requestAnimationFrame(this.renderNextAnimationFrame)
    },
    renderNextAnimationFrame() {
      if (!this.animationFrames.length) {
        return
      }

      this.frameNumber = this.animationFrames[0]
      this.animationFrames = this.animationFrames.slice(1)

      if (this.animationFrames.length) {
        requestAnimationFrame(this.renderNextAnimationFrame)
      }
    },
  },
}
